import { onError } from "@apollo/client/link/error";
import { SignOut } from "@clerk/types";
import { HASURA_INVALID_JWT_ERROR_CODE } from "@/types";

export function getErrorLink(signOut?: SignOut) {
  return onError(({ graphQLErrors }) => {
    if (graphQLErrors)
      graphQLErrors.forEach(({ extensions }) => {
        const code = extensions?.code;

        if (code === HASURA_INVALID_JWT_ERROR_CODE) {
          signOut &&
            signOut().catch((e) => {
              console.error(`[Apollo graphQLErrors handler error]: ${e}`);

              return false;
            });
        }

        return;
      });
  });
}
